/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Portrait_AltInputs */

const en_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach Mark Egly, PGA`)
};

const es_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenador Mark Egly, PGA`)
};

const de_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach Mark Egly, PGA`)
};

const zh_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教练 Mark Egly，PGA`)
};

const ar_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدرب Mark Egly، PGA`)
};

const fr_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach Mark Egly, PGA`)
};

const vi_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện viên Mark Egly, PGA`)
};

const sw_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kocha Mark Egly, PGA`)
};

const th_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โค้ช Mark Egly, PGA`)
};

const bs_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener Mark Egly, PGA`)
};

const ja_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチ Mark Egly（PGA）`)
};

const ko_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코치 Mark Egly, PGA`)
};

const pt_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinador Mark Egly, PGA`)
};

const it_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach Mark Egly, PGA`)
};

const sv_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tränare Mark Egly, PGA`)
};

const nl_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach Mark Egly, PGA`)
};

const da_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træner Mark Egly, PGA`)
};

const nb_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener Mark Egly, PGA`)
};

const fi_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmentaja Mark Egly, PGA`)
};

const pl_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener Mark Egly, PGA`)
};

const ru_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренер Mark Egly, PGA`)
};

const tr_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenör Mark Egly, PGA`)
};

const hi_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोच Mark Egly, PGA`)
};

const id_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatih Mark Egly, PGA`)
};

const ms_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurulatih Mark Egly, PGA`)
};

const cs_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenér Mark Egly, PGA`)
};

const el_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προπονητής Mark Egly, PGA`)
};

const he_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המאמן Mark Egly, PGA`)
};

const af_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrigter Mark Egly, PGA`)
};

const hu_about_portrait_alt = /** @type {(inputs: About_Portrait_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly edző, PGA`)
};

/**
* | output |
* | --- |
* | "Coach Mark Egly, PGA" |
*
* @param {About_Portrait_AltInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_portrait_alt = /** @type {((inputs?: About_Portrait_AltInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Portrait_AltInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_portrait_alt(inputs)
	if (locale === "de") return de_about_portrait_alt(inputs)
	if (locale === "zh") return zh_about_portrait_alt(inputs)
	if (locale === "ar") return ar_about_portrait_alt(inputs)
	if (locale === "fr") return fr_about_portrait_alt(inputs)
	if (locale === "vi") return vi_about_portrait_alt(inputs)
	if (locale === "sw") return sw_about_portrait_alt(inputs)
	if (locale === "th") return th_about_portrait_alt(inputs)
	if (locale === "bs") return bs_about_portrait_alt(inputs)
	if (locale === "ja") return ja_about_portrait_alt(inputs)
	if (locale === "ko") return ko_about_portrait_alt(inputs)
	if (locale === "pt") return pt_about_portrait_alt(inputs)
	if (locale === "it") return it_about_portrait_alt(inputs)
	if (locale === "sv") return sv_about_portrait_alt(inputs)
	if (locale === "nl") return nl_about_portrait_alt(inputs)
	if (locale === "da") return da_about_portrait_alt(inputs)
	if (locale === "nb") return nb_about_portrait_alt(inputs)
	if (locale === "fi") return fi_about_portrait_alt(inputs)
	if (locale === "pl") return pl_about_portrait_alt(inputs)
	if (locale === "ru") return ru_about_portrait_alt(inputs)
	if (locale === "tr") return tr_about_portrait_alt(inputs)
	if (locale === "hi") return hi_about_portrait_alt(inputs)
	if (locale === "id") return id_about_portrait_alt(inputs)
	if (locale === "ms") return ms_about_portrait_alt(inputs)
	if (locale === "cs") return cs_about_portrait_alt(inputs)
	if (locale === "el") return el_about_portrait_alt(inputs)
	if (locale === "he") return he_about_portrait_alt(inputs)
	if (locale === "af") return af_about_portrait_alt(inputs)
	if (locale === "hu") return hu_about_portrait_alt(inputs)
	return en_about_portrait_alt(inputs)
});